import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Injectable()
export class CustomerInvoiceForm {

  constructor(private formBuilder: FormBuilder) {
  }

  public buildForm(): FormGroup {
    return this.formBuilder.group({
      vat: [ '' ],
      paymentMethod: [ '' ],
      currency: [ '' ],
      transaction: [ '' ],
      transactionType: [ '' ],
      invoiceDate: [ '' ],
      status: [ '' ]
    });
  }
}
